module.exports = __webpack_public_path__ + "media/images/golden_pin_design_award_icon-b0617b8876c771af2fd028773438f5a0.png";